import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import moment from 'moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import avatar from '@material-ui/core/colors/grey';

import JobStatus from './JobStatus';

import { startEditAdmin } from '../../../store/actions/admin';
import { selectProjectTotals } from '../../../store/selectors';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  client: {
    width: "150px",
  },
  statusMessage: {
    display: 'flex',
    flexDirection: 'row',
  },
  statusMessageSpacer: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  flexGrow: {
    flexGrow: 1,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  total: {
    marginLeft: theme.spacing.unit*4,
    marginRight: theme.spacing.unit*4,
  },
  totalItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

const JobCard = ({ classes, project, projectTotals, client, startEditAdmin }) => {
  return(
    <Card className={classes.root}>
      <div
        className={classes.content}
        onClick={() => startEditAdmin({project: project})}
      >
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          J
        </Avatar>
        <div className={classNames(classes.client, classes.margin)}>
          {client &&
            <Typography noWrap variant="subheading">
              {client.fullName}
            </Typography>
          }
          <Typography noWrap variant="caption">
            {project.jobCode}
          </Typography>
        </div>
        <div>
          {project.startDate &&
            <Typography variant="subheading">
              {moment(project.startDate).format("MMM DD, YYYY")}
            </Typography>
          }
          {project.endDate &&
            <Typography variant="caption">
              {moment(project.endDate).format("MMM DD, YYYY")}
            </Typography>
          }
        </div>
        <div className={classNames(classes.total, classes.margin)}>
          {projectTotals.map((total, i) => {
            return (
              <div key={i} className={classes.totalItem}>
                <Typography>{`$${total.amount} ${total.type}`}</Typography>
              </div>

            );
          })}
        </div>
        <div className={classes.flexGrow}/>
      </div>
      <div className={classes.divider}></div>
      <div className={classNames(classes.status, classes.margin)}>
        <JobStatus project={project} />
      </div>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { project } = props;
  const client = project.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === project.clientId);

  return ({
    client: client,
    projectTotals: selectProjectTotals(state, project),
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(JobCard);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/JobCard.jsx